import hasClass from "./hasClass.es.js";
function addClass(element, className) {
  if (element.classList)
    element.classList.add(className);
  else if (!hasClass(element, className))
    if (typeof element.className === "string")
      element.className = element.className + " " + className;
    else
      element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
}
export {
  addClass as default
};
//# sourceMappingURL=addClass.es.js.map
